import { createAnalyticsColumnHeader } from './createAnalyticsColumnHeader';
import { CHARGE_COLUMN_NAME_MAP } from './constants/chargeColumnConfig';

/**
 * Charge column header component
 * Generated using shared factory to eliminate code duplication
 */
export const ChargeColumnHeader = createAnalyticsColumnHeader({
  tableType: 'CHARGES',
  columnNameMap: CHARGE_COLUMN_NAME_MAP,
});
